<template>
	<v-tabs
		class="round-card"
		height="34"
		background-color="background-1"
		slider-color="primary">
		<v-tab key="Campi" ripple class="secondary-tab">
			Campi
		</v-tab>
		<v-tab key="Azioni" ripple class="secondary-tab">
			Azioni
		</v-tab>
		<v-tab key="Categorie" ripple class="secondary-tab">
			Categorie
		</v-tab>
		<v-tab key="Stampa" ripple class="secondary-tab">
			Stampa
		</v-tab>
		<v-tab key="Template" ripple class="secondary-tab">
			Template
		</v-tab>
		<v-tab key="Altro" ripple class="secondary-tab">
			Altro
		</v-tab>
		<v-tab key="Duplicati" ripple class="secondary-tab">
			Duplicati
		</v-tab>

		<v-tab-item class="pb-offset background-1 pt-3" key="Campi">
			<v-row class="ma-0 pb-offset">

				<v-col class="pa-0 pt-2" cols="12">
					<fields-selector model-def="prospect"></fields-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Azioni">
			<v-row class="ma-0 pb-offset">

				<v-col class="pa-0 pt-2" cols="12">
					<actions-selector model-def="prospect"></actions-selector>
				</v-col>

			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Categorie">
			<v-row class="ma-0 pb-offset">
				<v-col class="pa-0 pt-6" cols="12">
					<crud
						title="Tipo Prospect"
						action-icon='settings'
						model-def='generaltypes-company_type'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
					<crud
						title="Stato Prospect"
						action-icon='settings'
						model-def='generaltypes-prospect_status'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
				<v-col class="pa-0 pt-6" cols="12">
					<crud
						title="Fonte Prospect"
						action-icon='settings'
						model-def='generaltypes-source'
						action-position='absolute'
						crudDialog
					></crud>
				</v-col>
			</v-row>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Stampa">
			<print-setting
				model="prospect"
			></print-setting>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Template">
			<crud
				model-def="templates-prospect"
				action-icon="dynamic_feed"
				title="Template"
			></crud>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Altro">
			<prospects-options
			></prospects-options>
		</v-tab-item>

		<v-tab-item class="pb-offset background-1 pt-3" key="Duplicati">
			<duplicate-settings
				model-type="prospect"
			></duplicate-settings>
		</v-tab-item>
	</v-tabs>
</template>
<script>

	import PrintSetting from '@/components/common/PrintSetting'
	import FieldsSelector from '@/components/common/FieldsSelector'
	import SelectorFields from '@/components/common/SelectorFields'
	import ActionsSelector from '@/components/common/ActionsSelector'
	import DuplicateSettings from '@/components/common/DuplicateSettings'
	import ProspectsOptions from '@/components/modules/crm/settings/ProspectsOptions'

	export default {
		name:'prospects-settings',
        components: {
			ProspectsOptions,
			PrintSetting,
			FieldsSelector,
			SelectorFields,
			ActionsSelector,
			DuplicateSettings,
        },
		data() {
			return {

			}
		},
	}
  </script>
